module.exports = __webpack_public_path__ + "static/media/latest-img-1.0a39a129.jpg";